var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.293 16.522a8.196 8.196 0 012.206 3.681c2.246 8.733 1.727 22.524.044 31.594a8.198 8.198 0 01-2.207 3.681 8.622 8.622 0 01-3.811 2.132C57.248 59 36.009 59 36.009 59s-21.238 0-26.515-1.39a8.622 8.622 0 01-3.812-2.132 8.197 8.197 0 01-2.207-3.681c-2.259-8.695-1.64-22.495-.043-31.552a8.196 8.196 0 012.207-3.681 8.622 8.622 0 013.811-2.132C14.727 13.042 35.966 13 35.966 13s21.238 0 26.515 1.39a8.622 8.622 0 013.812 2.132zM29.466 45.229A1 1 0 0128 44.344V27.656a1 1 0 011.466-.885l15.853 8.344a1 1 0 010 1.77l-15.853 8.344z",
    fill: "currentColor"
  })));
}

export default SvgYoutube;